const ENDPOINT_EMPLOYEE_ME = "/employees/me"
const ENDPOINT_EMPLOYEE_ME_SUBPROCESS = "/employees/me/subprocesses"
const ENDPOINT_SUBPROCESS_ALL = "/subprocesses"
const ENDPOINT_EMPLOYEE_SUBPROCESS_DETAIL = "/subprocesses/:id"
const ENDPOINT_EMPLOYEE_SUBPROCESS_FILE = "/subprocesses/:id/files"
const ENDPOINT_EMPLOYEE_ME_PROCESS = "/employees/me/processes"
const ENDPOINT_PROCESS_DETAIL = "/processes/:id"
const ENDPOINT_PROCESS_SUMMARY = "/processes/subprocess-summaries"
const ENDPOINT_EMPLOYEES = "/employees"
const ENDPOINT_NEW_TASK = "/processes"
const ENDPOINT_PROCESS_STATUSES = "/processes/statuses"
const ENDPOINT_PROCESS_TYPES = "/processes/types"
const ENDPOINT_DEPARTMENTS = "/departments"
const ENDPOINT_CENTERS = "/centers"
const ENDPOINT_UPDATE_TASK = "/processes/:id"
const ENDPOINT_UPDATE_SUBTASK = "/subprocesses/:id"

//$$
const ENDPOINT_PATCH_POSITION_SPECIFIC = "/employees/:id"
const ENDPOINT_PATCH_ALPS_CODE = "/employeesalps/:id"
const ENDPOINT_PATCH_FRECUENCY = "/employeefrecuency/:id"

const STATUS_NEW = 1
const STATUS_IN_PROGRESS = 2
const STATUS_RESOLVED = 3

const STATUS_READY_TO_RESOLVE = 4

const ALTA_TASK = 1
const BAJA_TASK = 4
const MANAGER_DEPARTMENT = 6

const HRO_ALPS = 3
const ALTA_CENTRO = 25


const NO_DELAYS_MESSAGE = "No delays have been identified in the planned schedule.";
const DATE_FORMAT = "YYYY-MM-DD";




export { 
    ENDPOINT_EMPLOYEE_ME_SUBPROCESS, 
    ENDPOINT_EMPLOYEE_SUBPROCESS_DETAIL, 
    ENDPOINT_SUBPROCESS_ALL, 
    ENDPOINT_EMPLOYEE_ME_PROCESS, 
    ENDPOINT_EMPLOYEES, 
    ENDPOINT_EMPLOYEE_ME, 
    ENDPOINT_PROCESS_DETAIL,
    ENDPOINT_PROCESS_SUMMARY,
    ENDPOINT_NEW_TASK,
    ENDPOINT_EMPLOYEE_SUBPROCESS_FILE,
    ENDPOINT_PROCESS_STATUSES,
    ENDPOINT_PROCESS_TYPES,
    ENDPOINT_DEPARTMENTS,
    ENDPOINT_CENTERS,
    STATUS_RESOLVED,
    STATUS_NEW,
    STATUS_IN_PROGRESS,
    ALTA_TASK,
    BAJA_TASK,
    ALTA_CENTRO,
    HRO_ALPS,
    ENDPOINT_UPDATE_TASK,
    ENDPOINT_UPDATE_SUBTASK,
    MANAGER_DEPARTMENT,
    DATE_FORMAT,
    ENDPOINT_PATCH_POSITION_SPECIFIC,
    ENDPOINT_PATCH_ALPS_CODE,
    ENDPOINT_PATCH_FRECUENCY,
    NO_DELAYS_MESSAGE,
    STATUS_READY_TO_RESOLVE
}